/**
 * Texts for Careers page
 */
export const careersPageText = {
    title: 'Karriär',
    titleMeta: 'Karriär — Lediga tjänster | CamDiab',
    descriptionMeta: 'Utforska karriärmöjligheter på CamDiab. Gå med i vårt team som förbättrar livet med diabetes.',
    keywords: 'CamDiab karriär, jobb, lediga tjänster, diabetes',
    localeMeta: 'sv_se',

    bannerTitle: 'Lediga tjänster',
    bannerSubtitle: 'Vill du bli en del av vårt team?',
    heroNote: 'Alla annonser publiceras på engelska.',

    introBody:
        'Letar du efter en ny utmaning och vill vara med och forma meningsfull förändring? Vi vill gärna höra från dig. Vi investerar i våra medarbetare — CamDiabs hjärta. Våra förmåner är utformade för att få det bästa ur alla, bland annat:',

    benefitsTitle: '',
    benefits: [
        'Generöst pensionsbidrag från arbetsgivaren',
        'Privat sjukförsäkring',
        'Livförsäkring',
        'Årlig diskretionär bonus',
        '29 semesterdagar plus 8 helgdagar',
        'Möjlighet att arbeta med banbrytande teknik som kan förändra diabetesvården och förbättra patientresultat',
        'Samarbetsinriktad och dynamisk arbetsmiljö',
        'Konkurrenskraftig lön och förmåner, inklusive utvecklings- och karriärmöjligheter',
    ],

    outroHtml:
        'Brinner du för verklig påverkan i vardagen? Vi vill gärna höra från dig:<a href="mailto:hr@camdiab.com" class="careers-email-link">hr@camdiab.com</a>',

    vacancies: [],

    emptyVacancyTitle: 'Inga lediga tjänster',
    emptyVacancyBody:
        'Vi kanske inte rekryterar just nu, men CamDiab växer, och vi vill gärna höra från personer som brinner för att förbättra livet med diabetes. Kom tillbaka senare.',

    applyLabel: 'Ansök nu',
};
